import { Menu, Transition } from '@headlessui/react';
import { Bars3Icon } from '@heroicons/react/24/outline';
import React, { Fragment } from 'react';

import { navigate } from 'gatsby';
import { EvolveLogo } from '../../assets/images/evolve-logo';
import { useLayoutContext, useLayoutControlContext } from '../../contexts';
import { NotificationBadge } from './notification-badge';

export const Topbar = () => {
  const { user, userNavigation, homeUrl, brandLogo, sidebar, notificationsSections } =
    useLayoutContext();
  const { setSidebarOpen, sidebarOpen } = useLayoutControlContext();
  const hasSidebar = !!sidebar;
  const onClickLogoHandler = () => {
    if (!homeUrl) {
      return;
    }
    if (homeUrl.startsWith('http://') || homeUrl.startsWith('https://')) {
      window.location.assign(homeUrl);
      return;
    }
    navigate(homeUrl);
  };

  return (
    <div
      className={
        'bg-evolve-secondary border-evolve-highlight sticky top-0 z-50 flex h-[80px] w-full flex-shrink-0 items-center gap-2 border-b pl-2 pr-4 hover:cursor-pointer'
      }
    >
      {brandLogo ? (
        <button
          type="button"
          onClick={onClickLogoHandler}
          className="border-0 bg-transparent p-0"
        >
          {brandLogo}
        </button>
      ) : (
        <EvolveLogo onClick={onClickLogoHandler} className="h-auto w-[140px]" />
      )}

      {hasSidebar && (
        <button
          type="button"
          className={
            'mt-2 border-gray-200 p-2 transition-all duration-300 ease-in-out hover:bg-white focus:ring-indigo-500'
          }
          onClick={() => setSidebarOpen(!sidebarOpen)}
        >
          <span className="sr-only">Abrir menu lateral</span>
          <Bars3Icon className="h-6 w-6" aria-hidden="true" />
        </button>
      )}

      <div className={'mt-2 flex flex-1 items-center justify-end gap-1 p-4'}>
        <div>
          <p className="hidden text-sm font-medium uppercase text-gray-700 group-hover:text-gray-900 md:flex">
            {user && user.name}
          </p>
        </div>

        <Menu as="div" className="relative ml-3">
          <Menu.Button
            className={
              'flex max-w-xs items-center rounded-full bg-white text-sm'
            }
          >
            <span className="sr-only">Abrir menu do utilizador</span>
            {/* ! Can make an Avatar component out of this */}
            <span className="bg-evolve-highlight inline-flex h-10 w-10 items-center justify-center rounded-full">
              <span className="font-medium leading-none text-white">
                {user && user.acronym}
              </span>
            </span>
          </Menu.Button>
          {userNavigation && (
            <Transition
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <Menu.Items className="options-menu-items-container">
                {userNavigation.map(({ to, label, onClick }, i) => (
                  <div
                    onClick={onClick ? onClick : () => navigate(to)}
                    key={`label--${i}`}
                    className="options-menu-item-button"
                  >
                    {label}
                  </div>
                ))}
              </Menu.Items>
            </Transition>
          )}
        </Menu>
        {notificationsSections && <NotificationBadge />}
      </div>
    </div>
  );
};
